var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFestival(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22L12 11M19.5 22L12 11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56601 11.9984C4.52194 11.6669 4.49989 11.3329 4.50001 10.9984C4.49856 9.86468 4.75503 8.74544 5.25001 7.72544M5.57801 14.8749C6.11417 15.7623 6.8283 16.5291 7.6754 17.1269C8.52251 17.7247 9.48424 18.1406 10.5 18.3484M13.5 18.3484C14.5266 18.1383 15.4978 17.7157 16.3512 17.1077C17.2047 16.4998 17.9215 15.72 18.4555 14.8184M19.434 11.9984C19.4775 11.6714 19.5 11.3374 19.5 10.9984C19.5016 9.86466 19.2452 8.74538 18.75 7.72544M13.5 3.64844C14.8024 3.91363 16.0105 4.52115 17 5.40844M10.5 3.64844C9.05676 3.9421 7.73237 4.65543 6.69301 5.69894",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5.82843 15 6.5 14.3284 6.5 13.5C6.5 12.6716 5.82843 12 5 12C4.17157 12 3.5 12.6716 3.5 13.5C3.5 14.3284 4.17157 15 5 15Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12.8284 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8284 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12.8284 5 13.5 4.32843 13.5 3.5C13.5 2.67157 12.8284 2 12 2C11.1716 2 10.5 2.67157 10.5 3.5C10.5 4.32843 11.1716 5 12 5Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.82843 8 7.5 7.32843 7.5 6.5C7.5 5.67157 6.82843 5 6 5C5.17157 5 4.5 5.67157 4.5 6.5C4.5 7.32843 5.17157 8 6 8Z",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C18.8284 8 19.5 7.32843 19.5 6.5C19.5 5.67157 18.8284 5 18 5C17.1716 5 16.5 5.67157 16.5 6.5C16.5 7.32843 17.1716 8 18 8Z",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15C19.8284 15 20.5 14.3284 20.5 13.5C20.5 12.6716 19.8284 12 19 12C18.1716 12 17.5 12.6716 17.5 13.5C17.5 14.3284 18.1716 15 19 15Z",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22H7M17 22H21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFestival);
export default __webpack_public_path__ + "static/media/icon-festival.53c394e0.svg";
export { ForwardRef as ReactComponent };